import { FC, useState } from "react"
import Form from "../../../form"
import { useFindPricingSetsQuery } from "../../../../../redux/queries"
import { useIntegrationSettingsForm } from "../../../../hooks"
import { Integration } from "../../../../../types"

interface Props {
  integration?: Integration
}

const PricingSetSelector: FC<Props> = ({ integration }) => {
  const { app_settings, saveAppSetting } =
    useIntegrationSettingsForm(integration)

  const { data: pricingSets = [], isLoading } = useFindPricingSetsQuery({
    brand_id: integration?.brand_id as string
  })

  const [selectedID, setSelectedPricingSetID] = useState<string>(
    String(app_settings?.pricing_set_id ?? "")
  )

  const setSelected = (pricingSetID: string) => {
    if (pricingSetID !== selectedID) {
      setSelectedPricingSetID(pricingSetID)
      saveAppSetting({ pricing_set_id: pricingSetID })
    }
  }

  return (
    <Form.Select
      label="Choose a set"
      showLabel={false}
      size="sm"
      isLoading={isLoading}
      data={pricingSets}
      setSelected={setSelected}
      selected={selectedID || undefined}
    />
  )
}

export default PricingSetSelector
